import MLAddressLookupComponent from './MLAddressLookupComponent/MLAddressLookupComponent';
import MLAddressVerificationModalComponent from './MLAddressVerificationModalComponent/MLAddressVerificationModalComponent';

const MLAddressLookupComponentMap = {
    MLAddressLookupComponent: { component: 'MLAddressLookupComponent' },
    MLAddressVerificationModalComponent: { component: 'MLAddressVerificationModalComponent' }
};

const MLAddressLookupComponents = {
    MLAddressLookupComponent,
    MLAddressVerificationModalComponent
};

export {
    MLAddressLookupComponentMap,
    MLAddressLookupComponents,
    // export single component
    MLAddressLookupComponent,
    MLAddressVerificationModalComponent
};
